import script from "./LockDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./LockDetail.vue?vue&type=script&setup=true&lang=ts"

import "./LockDetail.vue?vue&type=style&index=0&id=a9be979a&lang=css"

const __exports__ = script;

export default __exports__